/**
 * @generated SignedSource<<faf4e5a11005f2eda28d9408f3462031>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Bookmarks_viewer$data = {
  readonly account: {
    readonly uri: string;
  };
  readonly " $fragmentType": "Bookmarks_viewer";
};
export type Bookmarks_viewer$key = {
  readonly " $data"?: Bookmarks_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Bookmarks_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Bookmarks_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uri",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f92341e82c080799b72ef14a4568a91a";

export default node;
